import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M2.724 4h26.56c1.463 1.9 1.883 3.909 1.883 3.909.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-.415 1.985-1.858 3.876H2.725C1.282 26.11.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 .416-1.984 1.858-3.875",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M16 25.333a9.333 9.333 0 1 0 0-18.666 9.333 9.333 0 0 0 0 18.666",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M14.122 8.393q.69-.17 1.408-.212a.5.5 0 0 1 .06.998 7 7 0 0 0-1.229.185.5.5 0 0 1-.239-.97m4.888.373a8 8 0 0 0-1.36-.425.5.5 0 1 0-.21.978q.612.131 1.186.37a.5.5 0 1 0 .384-.923m1.874 1.11a8 8 0 0 1 1.028.985.5.5 0 0 1-.755.656 7 7 0 0 0-.897-.86.5.5 0 1 1 .624-.781M23.576 14a8 8 0 0 0-.488-1.338.5.5 0 0 0-.904.426q.266.563.425 1.167a.5.5 0 1 0 .967-.255m.256 2.145q-.013.72-.155 1.415a.5.5 0 1 1-.98-.198q.123-.607.135-1.235a.5.5 0 1 1 1 .018m-1.614 4.619q.435-.568.76-1.204a.5.5 0 1 0-.89-.455 7 7 0 0 1-.664 1.05.5.5 0 1 0 .794.609m-1.536 1.516a8 8 0 0 1-1.214.745.5.5 0 0 1-.443-.897 7 7 0 0 0 1.059-.65.5.5 0 1 1 .598.802m-3.264 1.424a8 8 0 0 1-1.418.128.5.5 0 1 1 0-1q.629 0 1.238-.111a.5.5 0 0 1 .18.983M12.105 9.202q-.62.356-1.166.819a.5.5 0 1 0 .646.763 7 7 0 0 1 1.017-.714.5.5 0 0 0-.498-.868m-3.29 3.674q.286-.655.684-1.248a.5.5 0 0 1 .83.558 7 7 0 0 0-.598 1.09.5.5 0 0 1-.917-.4m-.573 2.033a8 8 0 0 0-.068 1.44.5.5 0 1 0 1-.044 7 7 0 0 1 .06-1.257.5.5 0 0 0-.992-.139m.885 4.852a8 8 0 0 1-.568-1.307.5.5 0 0 1 .95-.313q.195.593.495 1.139a.5.5 0 0 1-.877.48m1.285 1.729q.501.51 1.086.921a.5.5 0 0 0 .575-.818 7 7 0 0 1-.948-.804.5.5 0 1 0-.713.7m4.358 2.247a8 8 0 0 1-1.381-.35.5.5 0 0 1 .333-.942q.586.206 1.204.305a.5.5 0 1 1-.156.987",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagBlz = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagBlz_default = SvgFlagBlz;

export { FlagBlz_default as default };
